import { FC, useContext, useEffect, useRef } from 'react'
import { importStorage } from './entities/importStorage'
import { useDecodeArrayBuffer } from './upload/hooks/useDecodeArrayBuffer'
import { readBlobAsArrayBuffer } from './upload/functions/readBlobAsArrayBuffer'
import { AppContext } from './AppContext'
import toast from 'react-hot-toast'
import { logger } from './logger/logger'
import { LogActionType } from 'api/logs/log-action-type'
import { getLogAudioBufferInfo } from './functions/getLogAudioBufferInfo'
import { getLogAudioBlobInfo } from './functions/getLogAudioBlobInfo'
import { getPossibleErrorMessage } from './functions/getPossibleErrorMessage'

export const Import: FC = () => {
  const { setAudioBuffer, setUploadOpened, setFilename } = useContext(AppContext)
  const decodeArrayBuffer = useDecodeArrayBuffer()
  const checkedRef = useRef(false)

  useEffect(() => {
    ;(async () => {
      if (!checkedRef.current) {
        checkedRef.current = true

        const blob = await importStorage.getAudioBlob()

        if (blob) {
          const toastId = toast.loading('Importing file for editing')

          logger.log(LogActionType.ImportBlob, getLogAudioBlobInfo(blob))

          readBlobAsArrayBuffer(blob)
            .then((arrayBuffer) => decodeArrayBuffer(arrayBuffer))
            .then((audioBuffer) => {
              logger.log(LogActionType.ImportSuccess)
              logger.log(LogActionType.UploadFileDecoded, getLogAudioBufferInfo(audioBuffer))

              setFilename('webcammictest.mp3')
              setAudioBuffer(audioBuffer)
              setUploadOpened(false)
            })
            .catch((reason) => {
              logger.log(LogActionType.ImportFail)
              logger.log(LogActionType.UploadDecodingError, getPossibleErrorMessage(reason))

              toast.error('Failed to import file for editing', {
                duration: 10000,
              })
            })
            .finally(() => {
              toast.dismiss(toastId)

              importStorage.removeAudioBlob()
            })
        }
      }
    })()
  }, [setAudioBuffer, setUploadOpened, setFilename, decodeArrayBuffer])

  return null
}
